import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { portfolioImages } from '../data';

export default function ImageLightbox({ imageIndex, onClose, onPrev, onNext }) {
  
  useEffect(() => {
    // Prevent scrolling on body when lightbox is open
    document.body.style.overflow = 'hidden';

    // Keyboard navigation
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, onPrev, onNext]);

  if (imageIndex === null || imageIndex === undefined || imageIndex < 0) return null;

  const currentImage = portfolioImages[imageIndex];

  return (
    <div 
      className="fixed inset-0 z-50 flex flex-col justify-between bg-black/95 p-4 backdrop-blur-xs"
      onClick={onClose}
    >
      {/* Top Bar */}
      <div className="flex justify-end items-center text-white py-2 px-4 z-10">
        <button
          onClick={onClose}
          className="bg-slate-900 hover:bg-orange-500 text-white p-2.5 transition-colors rounded-none cursor-pointer"
          aria-label="Luk"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Main Image Area with Navigation */}
      <div className="relative flex-1 flex items-center justify-center max-h-[80vh]" onClick={(e) => e.stopPropagation()}>
        {/* Left Arrow */}
        <button
          onClick={onPrev}
          className="absolute left-2 sm:left-4 bg-slate-900/80 hover:bg-sky-500 text-white p-3 transition-colors rounded-none z-10 cursor-pointer"
          aria-label="Forrige billede"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        {/* Image */}
        <img
          src={currentImage.url}
          alt={currentImage.alt || 'Udført arbejde'}
          className="max-w-full max-h-full object-contain select-none shadow-2xl border border-slate-800"
        />

        {/* Right Arrow */}
        <button
          onClick={onNext}
          className="absolute right-2 sm:right-4 bg-slate-900/80 hover:bg-sky-500 text-white p-3 transition-colors rounded-none z-10 cursor-pointer"
          aria-label="Næste billede"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      {/* Space for layout balance */}
      <div className="h-10 z-10" />

    </div>
  );
}
